import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';

import { ModalService } from '@app/core/modal.service';
import { FieldDataToShow } from '@app/models';
import { DocumentHistoryFormModalComponent as ModalComponent } from './document-history-form-modal.component';

@Injectable({ providedIn: 'root' })
export class DocumentHistoryFormModalService {
  constructor(private modalService: ModalService) {}

  open(properties: { documentId: string; signerFieldsData: FieldDataToShow[] }, options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.backdropClass = (newOptions.backdropClass || '').split(/\s+/).join(' ');
    newOptions.windowClass = (newOptions.windowClass || '').split(/\s+/).join(' ');
    return this.modalService.open(ModalComponent, properties, newOptions);
  }
}
